import * as Sentry from "@sentry/nextjs";

export function captureApiError(error) {
  const isNetworkOrCors =
    !error.response &&
    (error.code === "ERR_NETWORK" ||
      error.message === "Network Error" ||
      error.message?.includes("Failed to fetch"));

  if (!isNetworkOrCors && error.response?.status < 500) {
    return;
  }

  Sentry.captureException(error, {
    tags: {
      type: isNetworkOrCors ? "network_or_cors" : "api_error",
    },
    extra: {
      url: error.config?.url,
      method: error.config?.method,
      baseURL: error.config?.baseURL,
      status: error.response?.status,
      code: error.code,
    },
  });
}
